import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#6B0000] to-[#4A0000]">
        <div className="max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
            Legal
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6">
            Terms of Service
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 space-y-8">
            {/* Introduction */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Agreement to Terms
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Welcome to On Target Prints. By accessing or using our website and services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                These Terms apply to all visitors, users, and customers of On Target Prints, located at 123 Main Street, Starkville, MS 39759.
              </p>
            </div>

            {/* Services */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Our Services
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                On Target Prints provides custom apparel design and printing services. Our services include:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Online design studio for creating custom t-shirts and apparel</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Pre-designed Mississippi State themed apparel</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Local printing and fulfillment in Starkville, MS</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Shipping and local pickup options</span>
                </li>
              </ul>
            </div>

            {/* Account */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Account Registration
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                To place orders, you may need to create an account. You agree to:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Provide accurate, current, and complete information</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Maintain the security of your password</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Accept responsibility for all activities under your account</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Notify us immediately of any unauthorized use</span>
                </li>
              </ul>
            </div>

            {/* Orders */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Orders and Payment
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                When you place an order, you agree that:
              </p>
              <ul className="space-y-2 text-sm text-gray-600 mb-4">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>All orders are subject to acceptance and availability</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Prices are subject to change without notice</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Payment must be received before production begins</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>You are responsible for reviewing your design before submitting</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 leading-relaxed">
                We accept major credit cards, debit cards, and other payment methods as displayed at checkout. All payments are processed securely.
              </p>
            </div>

            {/* Custom Designs */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Custom Design Guidelines
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                When creating custom designs, you agree that:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                  <span>You will not upload copyrighted, trademarked, or offensive content</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                  <span>You will not use official Mississippi State University logos without permission</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-500 mt-0.5 flex-shrink-0"></i>
                  <span>You will not create designs that are hateful, discriminatory, or illegal</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                  <span>You own or have rights to all content you upload</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-green-500 mt-0.5 flex-shrink-0"></i>
                  <span>You grant us permission to print your design on apparel</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 leading-relaxed mt-4">
                We reserve the right to refuse any order that violates these guidelines or applicable laws.
              </p>
            </div>

            {/* Intellectual Property */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Intellectual Property Rights
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                All content on our website, including text, graphics, logos, images, and software, is the property of On Target Prints or its licensors and is protected by copyright and trademark laws.
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                You retain ownership of your custom designs. By submitting a design, you grant us a non-exclusive license to reproduce it for the purpose of fulfilling your order.
              </p>
            </div>

            {/* Shipping */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Shipping and Delivery
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                We aim to ship orders within 48 hours of production completion. However:
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Delivery times are estimates and not guaranteed</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>We are not responsible for carrier delays</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-[#6B0000] mt-0.5 flex-shrink-0"></i>
                  <span>Risk of loss passes to you upon delivery to the carrier</span>
                </li>
              </ul>
            </div>

            {/* Returns */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Returns and Refunds
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                Please refer to our <a href="/returns" className="font-bold text-[#6B0000] hover:underline cursor-pointer">Returns &amp; Exchanges Policy</a> for detailed information about returns, exchanges, and refunds.
              </p>
            </div>

            {/* Limitation of Liability */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Limitation of Liability
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                To the fullest extent permitted by law, On Target Prints shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our services. Our total liability shall not exceed the amount you paid for the specific product or service.
              </p>
            </div>

            {/* Indemnification */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Indemnification
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                You agree to indemnify and hold harmless On Target Prints from any claims, damages, or expenses arising from your use of our services, your violation of these Terms, or your infringement of any intellectual property or other rights.
              </p>
            </div>

            {/* Termination */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Termination
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                We reserve the right to suspend or terminate your account and access to our services at any time, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
              </p>
            </div>

            {/* Changes */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Changes to Terms
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                We may modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of our services after changes are posted constitutes acceptance of the modified Terms.
              </p>
            </div>

            {/* Governing Law */}
            <div>
              <h2 className="text-2xl font-black text-gray-900 mb-4">
                Governing Law
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                These Terms are governed by the laws of the State of Mississippi, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Mississippi.
              </p>
            </div>

            {/* Contact */}
            <div className="bg-red-50 rounded-lg p-6 border border-red-100">
              <h2 className="text-xl font-black text-gray-900 mb-3">
                Contact Us
              </h2>
              <p className="text-sm text-gray-600 mb-3">
                If you have questions about these Terms of Service, please contact us:
              </p>
              <div className="space-y-1 text-sm text-gray-900">
                <p><strong>Email:</strong> <a href="mailto:hello@ontargetprints.com" className="text-[#6B0000] hover:underline cursor-pointer">hello@ontargetprints.com</a></p>
                <p><strong>Address:</strong> 123 Main Street, Starkville, MS 39759</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}